import { o_util } from "@gr-common/async/namespaces";
import { otto } from "@gr-exports/async/nexus";
const domSync = o_util.dom ?? {};
const stringToDocumentFragment = domSync.stringToDocumentFragment;
const getFirstElementByTagName = domSync.getFirstElementByTagName;
const getHeadElement = domSync.getHeadElement;
const getBodyElement = domSync.getBodyElement;
const domAsync = otto.dom ?? {};
const onLoad = domAsync.onLoad;
const onReady = domAsync.onReady;
const onMount = domAsync.onMount;
const onUnmount = domAsync.onUnmount;
const insertHtmlFragment = domAsync.insertHtmlFragment;
const activateInlineScripts = domAsync.activateInlineScripts;
export {
  activateInlineScripts,
  domAsync,
  domSync,
  getBodyElement,
  getFirstElementByTagName,
  getHeadElement,
  insertHtmlFragment,
  onLoad,
  onMount,
  onReady,
  onUnmount,
  stringToDocumentFragment
};
